import script from "./szrDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./szrDialog.vue?vue&type=script&lang=ts&setup=true"

import "./szrDialog.vue?vue&type=style&index=0&id=23127155&lang=less&scoped=true"

import exportComponent from "D:\\test\\ieds-user-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23127155"]])

export default __exports__